import { observer } from 'mobx-react-lite';

import './style.sass';

import { Page } from 'app/components/common/PageLayout';
import { Button } from 'app/components/common/Button';
import { useBreakpointType } from 'app/services/breakpoints';
import { UsersTable } from 'app/components/UsersTable';
import { UsersCardsList } from 'app/components/UsersCardsList';
import { useModel } from 'app/hooks/useViewModel';
import { UsersPageViewModel } from 'app/viewModels/pages/UsersPageViewModel';


export const UsersPage = observer(() => {
    const { isMobile } = useBreakpointType();

    const {
        users,
        handleClickLoadMore,
        hasMore,
        isLoading,
    } = useModel(UsersPageViewModel);

    return (
        <Page className="users-page" isLoading={isLoading}>
            {isMobile
                ? <UsersCardsList users={users} />
                : <UsersTable users={users} />
            }

            {hasMore && (
                <div className="users-page__btn">
                    <Button
                        size="big"
                        colorType="primary-light"
                        text="Load more"
                        className="users-page__load-more-btn"
                        onClick={handleClickLoadMore}
                    />
                </div>
            )}
        </Page>
    );
});
